import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PageContainer from "../Layout/PageContainer";
import AddReviewForm from "./AddReviewForm";
import reviewService from "../../redux/services/review.service";
toast.configure();

const Review = (props) => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [review, setReview] = useState({});

    useEffect(() => {
        if (!/\d+/.test(id)) {
            navigate("/review/add");
        }
    }, [id, navigate]);

    useEffect(() => {
        if (props.currentUser.roleId === 2) {
            navigate("/dashboard");
        }
    }, [props.currentUser, navigate]);

    const getReview = (id) => {
        reviewService
            .get(id)
            .then((response) => {
                setReview(response.data.reviewInfo);
            })
            .catch((error) => {
                toast(error, {
                    transition: Slide,
                    closeButton: true,
                    autoClose: 3000,
                    position: "top-right",
                    type: "error",
                });
            });
    };

    useEffect(() => {
        if (id != "" && /\d+/.test(id)) getReview(id);
    }, [id]);

    return (
        <PageContainer
            pageTitleIcon="pe-7s-tools icon-gradient bg-plum-plate"
            pageHeading={
                id != "" && /\d+/.test(id) ? "Edit Review" : "Add Review"
            }
            pageSubTitle={
                id != "" && /\d+/.test(id)
                    ? "Edit Review information"
                    : "Save Review information"
            }
        >
            <AddReviewForm review={review} />
        </PageContainer>
    );
};

export default Review;
